const translations = {
  en: {
    Test: "Hello En Trans",
  },
  ar: {
    Test: "Hello Ar Trans",
  },
};
export default translations;
